<template>
	<div class="item-div" @click="toGoodsDetail">
		<div class="game-title-img-info-div">
			<div class="title-img-info">
				<img
					class="title-img"
					v-lazy="item.diyImage"
					:class="item.rankName && item.rankName.length > 0 ? 'rank-top-border' : ''"
				/>
				<div v-if="item.goldPrice && (item.goldPrice + '').length > 0" class="kjz-div">
					氪金值：¥{{ kejinGoldPrice }}
				</div>
				<img
					v-if="item.rankName && item.rankName.length > 0"
					class="rank-top-img"
					src="~@/images/new-home/rank-top.png"
				/>
			</div>
			<div class="title-detail-info-div">
				<div class="title-div">
					<span
						v-if="item.protoParams.shipeixitong && item.protoParams.zhanghaoleixingTX"
						class="area flex-row-center"
					>
						<span>{{ item.protoParams.shipeixitong }}|{{ item.protoParams.zhanghaoleixingTX }}</span>
					</span>
					<span
						class="goodsTitle"
						:class="[
							item.protoParams.shipeixitong && item.protoParams.zhanghaoleixingTX && 'goods-text-indent'
						]"
					>
						{{ item.gameId === 245 ? item.searchTitle : item.goodsTitle }}
					</span>
				</div>
				<div
					v-if="(rankFlag && rankFlag.rankFlag && rankFlag.rankname) || item.scoreSort"
					class="rank-div flex-row-center"
				>
					<div v-if="rankFlag && rankFlag.rankFlag && rankFlag.rankname" class="rank-guo-div flex-row-center">
						<img class="rank-guo-bg-1" :src="rankFlag.bg1" />
						<div
							class="rank-bg2"
							:class="[
								rankFlag.rankFlag === 1 && 'rank-guo-bg2',
								rankFlag.rankFlag === 2 && 'rank-sheng-bg2',
								rankFlag.rankFlag === 3 && 'rank-shi-bg2'
							]"
						>
							{{ rankFlag.rankname }}
						</div>
						<img class="rank-guo-bg-3" :src="rankFlag.bg3" />
					</div>
					<div v-if="item.scoreSort" class="hot-rank-div flex-row-center">
						<span class="hot-rank-span">
							上号率榜TOP
							<span class="number">{{ item.scoreSort }}</span>
							名
						</span>
						<img src="~@/images/new-home/hot-rank-arrow.png" />
					</div>
				</div>
				<template v-else>
					<div v-if="item.gameLabel && item.gameLabel.length > 0" class="game-label-div">
						<span class="label" v-for="(label, index) in item.gameLabel.split(',')" :key="index">
							{{ label }}
						</span>
					</div>
				</template>
				<div
					v-if="getImportantParamsArr(item.protoParams).length > 0"
					class="important-params-div flex-row-center"
				>
					<div
						v-for="(importantParam, index) in getImportantParamsArr(item.protoParams)"
						:key="index"
						class="important-params-item flex-col-center"
					>
						<span class="title">{{ importantParam.title }}</span>
						<span class="tip">{{ importantParam.tip }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="hot-money-div flex-row-center">
			<span class="hot">
				{{ item.showKeysText }}
				<span v-if="item.hotValue > 0" style="margin-left: 6rpx">| 热度{{ item.hotValue }}</span>
			</span>
			<span class="money">
				<span class="yuan">¥</span>
				{{ item.leasePrice }}
				<span class="hour">/时</span>
			</span>
		</div>

		<van-divider dashed />
		<div class="item-bottom-div flex-row-center">
			<div class="bottom-left-div flex-row-center">
				<div v-if="item.shfs && item.shfs.length > 0" class="bottom-span">
					{{ item.shfs }}
				</div>
				<div
					v-if="item.playQualifyingText && item.playQualifyingText.length > 0"
					class="bottom-span"
					:class="[
						(item.playQualifyingText === '仅可人机' || item.playQualifyingText === '不可排位') &&
							'grey-play-qualifying'
					]"
				>
					{{ item.playQualifyingText }}
				</div>
			</div>
			<div class="bottom-right-div flex-row-center">
				<div class="rent-btn" @click.stop="toGoodsDetail">立即租用</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			default: {}
		},
		importantParams: {
			type: Object,
			default: () => {
				return {};
			}
		},
		goodsId: {
			type: String,
			default: ''
		},
		parentName: {
			type: String,
			default: ''
		},
		collectType: {
			type: String,
			default: '' // 0收藏 1浏览
		},
		index: {
			type: Number,
			default: 0
		},
		pageSource: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {};
	},
	computed: {
		kejinGoldPrice() {
			if (this.item.goldPrice * 1 > 10000) {
				return `${((this.item.goldPrice * 1) / 10000).toFixed(1)}W`;
			}
			return this.item.goldPrice;
		},
		rankFlag() {
			let dic = {};
			if (this.item.protoParams) {
				if (this.item.protoParams.rankFlag) {
					dic['rankFlag'] = this.item.protoParams.rankFlag;
					if (dic['rankFlag'] === 1.0) {
						dic['rankname'] = this.item.protoParams.rankName;
						dic['bg1'] = require('../images/new-home/rank-guo-bg1.png');
						dic['bg3'] = require('../images/new-home/rank-guo-bg3.png');
					}
					if (dic['rankFlag'] === 2.0) {
						dic['rankname'] = this.item.protoParams.proLogo;
						dic['bg1'] = require('../images/new-home/rank-sheng-bg1.png');
						dic['bg3'] = require('../images/new-home/rank-sheng-bg3.png');
					}
					if (dic['rankFlag'] === 3.0) {
						dic['rankname'] = this.item.protoParams.cityLogo;
						dic['bg1'] = require('../images/new-home/rank-shi-bg1.png');
						dic['bg3'] = require('../images/new-home/rank-shi-bg3.png');
					}
				}
			}
			return dic;
		}
	},
	methods: {
		getImportantParamsArr(protoParams) {
			let keys = {};
			let values = {};
			if (Object.prototype.toString.call(this.importantParams).slice(8, -1) === 'Object') {
				keys = Object.keys(this.importantParams);
				values = Object.values(this.importantParams).map((value) => value.split('|')[0]);
			}
			if (keys.length === 0) {
				return [];
			}
			let arr = [];
			var isHaveValue = false;
			for (var i = 0; i < keys.length; i++) {
				if (protoParams[values[i]]) {
					isHaveValue = true;
				}
				arr.push({
					title: protoParams[values[i]] || '-',
					tip: keys[i] || '-'
				});
			}
			if (isHaveValue === false) {
				return [];
			}
			if (arr.length > 3) {
				arr = arr.slice(0, 3);
			} else {
				while (arr.length < 3) {
					arr.push({
						title: '-',
						tip: '-'
					});
				}
			}
			return arr;
		},
		toGoodsDetail() {
			this.$router.push({
				path: 'goodsdetail',
				query: {
					goodsId: this.item.goodsId,
					gameId: this.item.bigGameId,
					stickorder: this.item.stickorder, // 置顶埋点用
					itemIndex: this.index, // 置顶埋点用
					pageSource: this.pageSource // 页面埋点 用户访问来源：1.首页 2.商品列表 3.其他
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.flex-row-center {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.flex-col-center {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.box-sizing {
	box-sizing: border-box;
}

.item-div {
	box-sizing: border-box;
	width: 7.02rem;
	padding: 0.26rem 0.26rem 0.18rem 0.26rem;
	background: #ffffff;
	border-radius: 0.24rem;
	margin: 0 auto 0.28rem;

	.game-title-img-info-div {
		display: flex;
		flex-direction: row;

		.title-img-info {
			position: relative;
			width: 2rem;
			height: 2rem;
			border-radius: 0.08rem;
		}

		.title-img {
			width: 2rem;
			height: 2rem;
			border-radius: 0.08rem;
		}

		.rank-top-border {
			border: 0.02rem solid #ffd666;
		}

		.kjz-div {
			position: absolute;
			bottom: 0;
			left: 0.1rem;
			right: 0.1rem;
			font-size: 0.2rem;
			font-family: SourceHanSansCN-Regular, SourceHanSansCN;
			font-weight: 400;
			color: #fff1aa;
			line-height: 0.3rem;
			width: 1.8rem;
			height: 0.28rem;
			text-align: center;
			background: linear-gradient(180deg, #818181 0%, #4a4a4a 100%);
			border-top-right-radius: 0.26rem;
			border-top-left-radius: 0.26rem;
		}

		.rank-top-img {
			position: absolute;
			width: 1.28rem;
			height: 0.56rem;
			left: 0.36rem;
			top: -0.22rem;
		}
	}

	.title-detail-info-div {
		margin-left: 0.24rem;
		flex: 1;

		.title-div {
			position: relative;
			margin-bottom: 0.14rem;
			overflow: hidden;
		}

		.goodsTitle {
			font-size:14px;
			font-family: SourceHanSansCN-Medium, SourceHanSansCN;
			font-weight: 700;
			color: #29354d;
			height: 0.8rem;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
		}

		.goods-text-indent {
			text-indent: 1.22rem;
		}

		.area {
			display: inline-block;
			height: 0.34rem;
			// line-height: 0.34rem;
			background: #f2fcfb;
			border-radius: 0.06rem;
			border: 0.02rem solid #abf0eb;
			font-size: 0.24rem;
			text-align: center;
			text-wrap: nowrap;
			font-family: SourceHanSansCN-Medium, SourceHanSansCN;
			font-weight: 700;
			color: #17c3b3;
			position: absolute;
			top: 0;
			width: 1.24rem;
			left: 0;
			transform: scale(0.917);
		}

		.rank-div {
			height: 0.32rem;
			margin-bottom: 0.14rem;

			.rank-guo-div {
				margin-right: 0.16rem;

				.rank-guo-bg-1 {
					width: 0.38rem;
					height: 0.3rem;
				}

				.rank-guo-bg2 {
					background: url('~@/images/new-home/rank-guo-bg2.png') no-repeat;
				}

				.rank-sheng-bg2 {
					background: url('~@/images/new-home/rank-sheng-bg2.png') no-repeat;
				}

				.rank-shi-bg2 {
					background: url('~@/images/new-home/rank-shi-bg2.png') no-repeat;
				}

				.rank-bg2 {
					background-size: 100% 100%;
					height: 0.3rem;
					line-height: 0.3rem;
					font-size: 0.2rem;
					font-family: SourceHanSansCN-Normal, SourceHanSansCN;
					font-weight: 400;
					color: #ffffff;
				}

				.rank-guo-bg-3 {
					margin-left: -0.01rem;
					width: 0.1rem;
					height: 0.3rem;
				}
			}

			.hot-rank-div {
				height: 0.3rem;
				background: #ffeddd;
				border-radius: 0.12rem 0.12rem 0.12rem 0;
				padding: 0.04rem 0.04rem 0.04rem 0.12rem;

				.hot-rank-span {
					font-size: 0.2rem;
					font-family: SourceHanSansCN-Normal, SourceHanSansCN;
					font-weight: 400;
					color: #894e22;

					.number {
						font-family: Roboto-Regular, Roboto;
						margin: 0 0.02rem;
					}
				}

				img {
					height: 0.2rem;
					width: 0.2rem;
					margin-left: 0.06rem;
				}
			}
		}

		.game-label-div {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			overflow: hidden;
			height: 0.3rem;

			.label {
				text-align: center;
				height: 0.3rem;
				line-height: 0.3rem;
				background: #f3f4f8;
				border-radius: 0.12rem;
				font-size: 0.2rem;
				font-family: SourceHanSansCN-Normal, SourceHanSansCN;
				font-weight: 400;
				color: #a2a0aa;
				padding: 0 0.15rem;
				margin: 0 0.08rem 0.08rem 0;
			}
		}
	}

	.important-params-div {
		margin-top: 0.1rem;
		// height: 0.68rem;
		padding: 0.1rem 0;
		background: linear-gradient(94deg, #ebf4fc 0%, #f4fbff 33%, #f8f9fe 72%, #fff5fd 100%);
		border: 0.02rem solid #e9f0fc;

		.important-params-item {
			flex: 1;
			justify-content: center;
			position: relative;

			.title {
				text-align: center;
				font-size: 0.24rem;
				font-family: Roboto-Bold, Roboto;
				font-weight: bold;
				color: #787786;
				line-height: 0.22rem;
			}

			.tip {
				text-align: center;
				font-size: 0.18rem;
				font-family: SourceHanSansCN-Regular, SourceHanSansCN;
				font-weight: 400;
				color: #a2a0aa;
				line-height: 0.22rem;
				margin-top: 0.1rem;
			}

			&::before {
				content: ' ';
				position: absolute;
				right: 0;
				width: 0.01rem;
				height: 0.2rem;
				background: #dbdfe6;
				border-radius: 0.01rem;
			}

			&:last-child::before {
				position: absolute;
				background: #dbdfe6;
				width: 0;
			}
		}
	}

	.hot-money-div {
		margin-top: 0.26rem;
		justify-content: space-between;

		.hot {
			font-size: 0.22rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #a2a1a9;
		}

		.money {
			font-size: 0.36rem;
			font-family: Roboto-Bold, Roboto;
			font-weight: bold;
			color: #ff345d;

			.yuan {
				font-size: 0.2rem;
				font-family: SourceHanSansCN-Bold, SourceHanSansCN;
			}

			.hour {
				color: #a2a0aa;
				font-size: 0.2rem;
				font-family: SourceHanSansCN-Regular, SourceHanSansCN;
				font-weight: 400;
			}
		}
	}

	/deep/ .van-divider {
		margin: 0.22rem 0 0;
		color: #f3f4f5;
	}

	.item-bottom-div {
		justify-content: space-between;
		margin-top: 0.18rem;

		.bottom-span {
			font-size: 0.2rem;
			font-family: SourceHanSansCN-Regular, SourceHanSansCN;
			font-weight: 400;
			color: #e1920b;
			padding: 0 0.04rem;
			border-radius: 0.08rem;
			border: 0.02rem solid #f8c072;
			margin-right: 0.08rem;
		}

		.grey-play-qualifying {
			color: #8e92a5;
			border: 0.02rem solid #8e92a5;
		}

		.actity {
			color: #f31a4d;
			border: 0.02rem solid #f31a4d;
		}

		.cancel-favorite {
			margin-right: 0.1rem;

			> img {
				width: 0.4rem;
				height: 0.4rem;
			}

			> span {
				font-weight: 400;
				font-size: 0.24rem;
				color: #a2a0aa;
				line-height: 0.24rem;
			}
		}

		.remove {
			margin-right: 0.16rem;
			box-sizing: border-box;
			width: 1.08rem;
			height: 0.56rem;
			border-radius: 0.28rem;
			border: 0.02rem solid #c9cbd6;
			font-weight: 400;
			font-size: 0.28rem;
			color: #8e92a5;
			text-align: center;
			line-height: 0.56rem;
		}

		.rent-btn {
			text-align: center;
			width: 1.64rem;
			height: 0.56rem;
			background: linear-gradient(90deg, #5592fc 0%, #6dcfff 100%);
			border-radius: 0.28rem;
			font-size: 0.26rem;
			font-family: SourceHanSansCN-Medium, SourceHanSansCN;
			font-weight: 700;
			color: #ffffff;
			line-height: 0.56rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/game-item.vue